let item_price_origin = 0
let interval = setInterval(function () {
  let ap_elements = document.querySelector('#avpoptions-container');
  
  if (ap_elements){
    let avp_price = $('#avp-productoption-totalpriceadd')[0];
    let item_price = $('#ProductPrice')[0];
    
    if (avp_price && item_price){
      if (item_price_origin == 0){
      	item_price_origin = parseFloat($('#ProductPrice')[0].innerHTML.replace('$',''));
      }
    	let total_price = item_price_origin + parseFloat(avp_price.innerHTML.replace('$',''));
    	item_price.innerHTML = '$' + total_price.toString(); 
    } 
    if ($('#avp-productoption-total-add').is(':visible') == false){
    	item_price.innerHTML = '$' + item_price_origin.toString(); 
    }
    
  } 
}, 100);